import React from 'react'
import '../SolicitudGastosContingenciaProfesional/SelectorGastosContingencia.scss'
import { Link, useNavigate } from 'react-router-dom'
import PageMenu from 'components/blocks/PageMenu/PageMenu'
import Icon from 'components/blocks/Icon/Icon'
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";

const gastosOptions = [
    {
        tipoGasto: 1,
        icon: 'truck',
        title: 'Gastos de Transporte',
        sub: 'Gastos relacionados con el Desplazamiento a los centros designados',
    },
    {
        tipoGasto: 2,
        icon: 'pill',
        title: 'Gastos de Farmacia',
        sub: 'Gastos relacionados con la compra de medicamentos y sus derivados',
    },
    {
        tipoGasto: 3,
        icon: 'bone',
        title: 'Gastos de Ortopedia',
        sub: 'Gastos relacionados con la Ortopedia',
    },
];

export const SelectorGastosContingencia = ({ expedienteId = null, origen = null }) => {

    //SelectorGastosContingencia sirve para seleccionar el tipo de gasto que va a ver el usuario
    const navigate = useNavigate();

    return (

        <section className="container">
            <PageMenu title={'Seleccione el tipo de gasto'} >
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>
            <div className="gastos-grid">
                {gastosOptions.map(option => (
                    <Link
                        key={option.tipoGasto}
                        to={`/solicitud-gastos-contingencia-profesional/${option.tipoGasto}`}
                        state={{ expedienteId, origen }}
                        className="gastos-tile"
                    >
                        <div className="gastos-tile__icon">
                            <Icon name={option.icon} size={26} />
                        </div>
                        <div>
                            <h5 className="gastos-tile__title">{option.title}</h5>
                            <p className="gastos-tile__sub">{option.sub}</p>
                        </div>
                        <span className="gastos-tile__arrow">
                            <Icon name="arrow-right" size={20} />
                        </span>
                    </Link>
                ))}
            </div>

        </section>
    )
}
